export enum PhoneNumberType {
  None = 'None',
  Home = 'Home',
  Mobile = 'Mobile',
  Work = 'Work',
}
